import classes from "./Select.module.css";
import classNames from "classnames";
import Chevron from "static/icons/chevron.svg";
import { useClickOutside } from "@mantine/hooks";

import { useState, useCallback } from "react";
import Image from "next/image";
import { Option } from "utils/interfaces/commonInterfacesAndTypes";
import useTranslation from "next-translate/useTranslation";

type Props = {
  selectedOption: Option | null;
  options: Option[];
  onChangeHandler: (option: Option) => void;
  placeholder?: string;
  className?: string;
  dropdownClassName?: string;
  withoutTranslation?: boolean;
};

const Select = ({
  selectedOption,
  onChangeHandler,
  options,
  placeholder,
  className,
  dropdownClassName,
  withoutTranslation,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickOutside(() => setIsOpen(false));
  const { t } = useTranslation("common");

  const handleSelect = useCallback(
    (option: Option) => {
      onChangeHandler(option);
      setIsOpen(false);
    },
    [setIsOpen, onChangeHandler]
  );
  const getDisplayedName = (option: Option) =>
    withoutTranslation ? option.label : t(option.label);

  return (
    <div
      ref={ref}
      className={classNames(
        classes.container,
        { [classes.active]: isOpen },
        className
      )}
    >
      <div
        {...(!isOpen && {
          onClick: () => {
            setIsOpen(true);
          },
        })}
        className={classes.select}
      >
        {selectedOption ? getDisplayedName(selectedOption) : placeholder}
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={classNames(classes.iconContainer, {
            [classes.iconContainerActive]: isOpen,
          })}
        >
          <Image src={Chevron} alt="Chevron" />
        </div>
      </div>
      <div
        className={classNames(
          classes.dropdown,
          { [classes.active]: isOpen },
          dropdownClassName
        )}
      >
        {options.map((option) => (
          <div
            onClick={() => handleSelect(option)}
            className={classes.option}
            key={option.value}
          >
            {getDisplayedName(option)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Select;
